import * as React from 'react';

function SvgGetStarted(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={50} height={50} {...props}>
      <defs>
        <style>{'.get_started_svg__prefix__cls-2{fill:#7689b4}'}</style>
      </defs>
      <g id="get_started_svg__prefix__get_started" transform="translate(-26 -193)">
        <path
          id="get_started_svg__prefix__bounds"
          fill="none"
          d="M0 0h50v50H0z"
          transform="translate(26 193)"
        />
        <g id="get_started_svg__prefix__rocket" transform="translate(30 196.999)">
          <path
            id="get_started_svg__prefix__Path_4996"
            d="M40.171 366.315a.626.626 0 00-.886 0l-2.129 2.129a.626.626 0 00.886.886l2.129-2.129a.626.626 0 000-.886z"
            className="get_started_svg__prefix__cls-2"
            data-name="Path 4996"
            transform="translate(-33.885 -335.558)"
          />
          <path
            id="get_started_svg__prefix__Path_4997"
            d="M64.979 391.123a.626.626 0 00-.886 0l-2.129 2.129a.626.626 0 00.886.886l2.129-2.129a.626.626 0 000-.886z"
            className="get_started_svg__prefix__cls-2"
            data-name="Path 4997"
            transform="translate(-56.622 -358.294)"
          />
          <path
            id="get_started_svg__prefix__Path_4998"
            d="M113.708 440.738l-2.129 2.129a.626.626 0 10.886.886l2.129-2.129a.626.626 0 10-.886-.886z"
            className="get_started_svg__prefix__cls-2"
            data-name="Path 4998"
            transform="translate(-102.094 -403.766)"
          />
          <path
            id="get_started_svg__prefix__Path_4999"
            d="M89.786 415.931a.626.626 0 00-.886 0l-2.129 2.129a.626.626 0 00.886.886l2.129-2.129a.626.626 0 000-.886z"
            className="get_started_svg__prefix__cls-2"
            data-name="Path 4999"
            transform="translate(-79.357 -381.031)"
          />
          <path
            id="get_started_svg__prefix__Path_5000"
            d="M41.193.051L28.086 3.882a.625.625 0 00-.267.158l-8.758 8.76-3.913.329A23.682 23.682 0 00.407 19.973a1.382 1.382 0 00.857 2.354l7.605.664-.788.788a1.251 1.251 0 000 1.77l.761.761L7.3 27.852a1.551 1.551 0 000 2.191l5.412 5.412a1.551 1.551 0 002.191 0l1.542-1.542.72.72a1.311 1.311 0 001.851 0l.747-.747.664 7.605a1.382 1.382 0 002.354.857 23.489 23.489 0 005.457-8.517.626.626 0 00-1.175-.435 22.246 22.246 0 01-5.163 8.066.129.129 0 01-.22-.08l-.756-8.653 7.665-7.665a34 34 0 01-.678 5.489.626.626 0 101.222.276 46.7 46.7 0 00.827-7.135l8.759-8.759a.626.626 0 00.158-.267l1.739-5.95L42.7 1.561a1.218 1.218 0 00-1.507-1.51zm-1.488 7.3l-4.3-4.3 6.08-1.777zM1.292 20.859a22.428 22.428 0 0113.96-6.482l2.436-.2-7.663 7.663-8.653-.756a.129.129 0 01-.08-.225zM23.9 19.38l-8.37 8.373-4.111 4.111a.374.374 0 11-.529-.529l12.484-12.484a.374.374 0 11.528.529zm-11.524 8.7l-3.409-3.415 1.3-1.3 3.411 3.411zm-4.194.662l1.543-1.543 1.766 1.766-1.516 1.515a1.6 1.6 0 00-.209.259l-1.581-1.582a.3.3 0 010-.42zm5.832 5.832a.3.3 0 01-.42 0l-1.581-1.581a1.6 1.6 0 00.259-.209l1.519-1.519 1.766 1.766zm.662-4.194l1.294-1.294 3.411 3.411-1.251 1.25a.056.056 0 01-.075 0zm23.038-16.217L20.27 31.607 16.859 28.2l7.96-7.96a1.627 1.627 0 00-2.3-2.3l-7.96 7.96-3.411-3.411L28.591 5.04l5.44-1.59L39.3 8.723z"
            className="get_started_svg__prefix__cls-2"
            data-name="Path 5000"
          />
          <path
            id="get_started_svg__prefix__Path_5001"
            d="M302.471 119.274a.626.626 0 00-.515 1.142 2.922 2.922 0 11-2.407 0 .626.626 0 00-.515-1.142 4.174 4.174 0 103.438 0z"
            className="get_started_svg__prefix__cls-2"
            data-name="Path 5001"
            transform="translate(-271.813 -109.262)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgGetStarted;
